import * as DialogRadix from '@radix-ui/react-dialog'
import { Button, Dialog } from '@/components'

import { useReportDemand } from '@/hooks/useReportDemand'
import { useNavigate } from 'react-router-dom'

export interface ReportData{
  created_by: number
  emails: string[]
  issues: string[]
  comments: string
  resolution?: string
}

interface ReportDialogProps {
  demandId: string
  demandName: string
  reportData: ReportData
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  action: 'refuse' | 'report'
}

export function ReportDialog({
  demandId,
  demandName,
  reportData,
  isOpen,
  setIsOpen,
  action
}: ReportDialogProps) {
  const navigate = useNavigate()
  const { reportDemandMutate, isReportDemandLoading } = useReportDemand({
    onSuccess: () => {
      setIsOpen(false)
      navigate(`/demands/${demandId}`)
    }
  })

  return (
    <Dialog isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="flex w-[37.6875rem] flex-col p-6">
        <DialogRadix.Title asChild>
          <h1 className="mb-2 text-titleLarge text-cromai-m3-sys-light-on-surface dark:text-cromai-m3-sys-dark-on-surface">
            {action === 'refuse' ? 'Recusar demanda' : 'Reportar demanda'}
          </h1>
        </DialogRadix.Title>
        <DialogRadix.Description asChild>
          <span className="mb-8 font-mono text-bodyLarge text-cromai-m3-sys-light-on-surface-variant dark:text-cromai-m3-sys-dark-on-surface-variant">
            {action === 'refuse' ? 'Você tem certeza que deseja recusar a demanda' : 'Você tem certeza que deseja reportar a demanda'}
            <strong> {demandName}</strong>? O Cliente será notificado após a confirmação!
          </span>
        </DialogRadix.Description>
        <div className="flex w-full items-center justify-between">
          <DialogRadix.Close asChild>
            <Button variant="outlined">Cancelar</Button>
          </DialogRadix.Close>
          <Button
            className="w-36"
            loading={isReportDemandLoading}
            onClick={() => reportDemandMutate({ demandId, reportData})}
          >
            {action === 'refuse' ? 'Recusar demanda' : 'Reportar demanda'}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
